var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackShade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 118,
    viewBox: "0 0 230 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.78 0C55.074 5.24737 50.7472 20.0034 32.9228 26.6967C15.6295 33.1906 4.23695 30.9575 0.000319808 28.8585L0.00031874 15.3333C0.000318071 6.86497 6.86525 4.73395e-06 15.3336 3.91438e-06L55.78 0Z",
    fill: "#E7E7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230 102.022C229.988 110.474 223.138 117.323 214.686 117.333H128.196C132.236 105.833 149.111 82.8333 184.292 82.8333C219.473 82.8333 229.423 64.9444 230 56V102.022Z",
    fill: "#E7E7E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackShade);
export default __webpack_public_path__ + "static/media/black_shade.a8788613e7a3e1f2e70ec184675a2e39.svg";
export { ForwardRef as ReactComponent };